import { createApp } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { createBootstrap } from "bootstrap-vue-next";
import VueMultiselect from "vue-multiselect";
import CourseAppointmentApp from "./CourseAppointmentApp.vue";
import {
	roomBookingQueryClient,
	initUrlConfig,
} from "../../../room-booking-management/api";

$(document).ready(function () {
	// Only on the course appointment index page.
	if (
		!/\/course-management\/semester\/\d+\/course\/\d+\/appointment$/.test(
			window.location.pathname
		)
	) {
		return;
	}

	const container = document.getElementById("course-appointment-app");
	if (!container) {
		return;
	}

	const apiUrl = container.dataset.apiUrl;
	const userApiUrl = container.dataset.userApiUrl;
	const roomBookingApiUrl = container.dataset.roomBookingApiUrl;
	const lecturePeriodStart = container.dataset.lecturePeriodStart || null;
	const lecturePeriodEnd = container.dataset.lecturePeriodEnd || null;
	const employeeSearchApiUrl = container.dataset.employeeSearchApiUrl || null;
	const defaultTitle = container.dataset.defaultTitle || "";
	const defaultEmployeeId = container.dataset.defaultEmployeeId
		? Number(container.dataset.defaultEmployeeId)
		: null;
	const defaultEmployeeName = container.dataset.defaultEmployeeName || "";
	let nonTeachingDates = {};
	try {
		nonTeachingDates = JSON.parse(container.dataset.nonTeachingDates || "{}");
	} catch {
		nonTeachingDates = {};
	}

	if (!apiUrl || !userApiUrl || !roomBookingApiUrl) {
		console.error("Missing configuration for course appointment app");
		return;
	}

	// Master data (rooms, booking types) is reused from the room booking system.
	if (!initUrlConfig || !roomBookingApiUrl) {
		return;
	}
	try {
		initUrlConfig({ userApiUrl, roomBookingApiUrl });
	} catch {
		// already initialized – ignore
	}

	const app = createApp(CourseAppointmentApp, {
		apiUrl,
		lecturePeriodStart,
		lecturePeriodEnd,
		employeeSearchApiUrl,
		defaultTitle,
		defaultEmployeeId,
		defaultEmployeeName,
		nonTeachingDates,
	});
	app.use(VueQueryPlugin, { queryClient: roomBookingQueryClient });
	app.use(createBootstrap());
	app.component("VMultiselect", VueMultiselect);
	app.mount(container);
});
